import { VStack, Box, Flex } from "@chakra-ui/react";
import { Form, Skeleton } from "antd";
import TransferBar from "components/TransferBar";
import PayoutsTable from "components/customer/Payouts/PayoutsTable";
import { useIdentity } from "context/auth";
import useAccountSummary from "hooks/useAccountSummary";
import { FC } from "react";
import { centsToDollars, valueOrUnknown } from "util/helpers";

const RequestPayoutPage: FC = () => {
    const { accounts } = useIdentity();
    const { isLoading, data } = useAccountSummary(accounts[0]);

    const availableBalance = valueOrUnknown(
        data?.availableBalanceInCents,
        centsToDollars,
    );
    return (
        <VStack
            as={Form}
            align="start"
            spacing={7}
            p={{ base: 0, md: 10 }}
            w="100%"
            color="var(--dcs-white)"
        >
            <Flex
                justifyContent="center"
                alignItems="center"
                display="flex"
                w="100%"
                bgColor="black"
                p={4}
                borderRadius="xl"
                flexDir="column"
                gap={4}
            >
                <Box fontSize={52} color="var(--dcs-blue)" fontWeight="bold">
                    {isLoading ? <Skeleton.Input active /> : availableBalance}
                </Box>
                <TransferBar />
            </Flex>
            <PayoutsTable />
        </VStack>
    );
};

export default RequestPayoutPage;
